import React from "react";
import {Button} from "@cuatroochenta/co-admin-react-library";

interface ExportMobilisConfigurationViewProps {
    onClick: () => void,

}

export const ExportMobilisConfigurationView = (
    {
        onClick,
    }: ExportMobilisConfigurationViewProps
): React.ReactElement => {
    return <Button content={'Exportar'} onClick={onClick}/>;
}